import axios from "axios";
import { ElMessage } from "element-plus";
import store from "@/store/index";
import router from "@/router"
//store.commit("setimageurl", "http://192.168.11.3:8081/api");
//store.commit("setimageurl", "http://172.28.43.145:8081");
store.commit("setimageurl", "https://www.sdjk123.cn/api");
//store.commit("setimageurl", "http://47.120.49.8:8081");
// 创建axios实例
const service = axios.create({
  //baseURL: "http://192.168.11.3:8081/api",
  // baseURL: "http://47.120.49.8:8081",
  baseURL: "https://www.sdjk123.cn/api",
  //baseURL: "http://47.120.49.8:8081",
  timeout: 15000,
  headers: {
    "Content-Type": "application/json;charset=utf-8",
    type: "admin",
  },
});
// 请求拦截
service.interceptors.request.use((config) => {
  config.headers = config.headers || {};
  if (localStorage.getItem("token")) {
    config.headers.token = localStorage.getItem("token") || "";
  }
  return config;
});
// 响应拦截
service.interceptors.response.use(
  (res: any) => {
    // 1. 放行文件下载请求
    if (res.config.responseType === 'blob' || res.data instanceof Blob) {
      return res;
    }

    // 2. 处理业务逻辑错误（HTTP 200，但 code 不是 200）
    const { code, msg } = res.data;
    if (!code)return res
    if (code !== 200) {
      if (code === 300) {
        ElMessage.error(msg || "操作失败");
        return Promise.reject(new Error(msg));
      } else {
        // 根据 headers.type 决定跳转路径
        const requestType = res.config.headers?.type;
        const redirectPath = requestType === "user" ? "/about" : "/login";
        router.push(redirectPath);
        return Promise.reject(new Error(msg || `请求失败，错误码: ${code}`));
      }
    }

    // 3. 正常返回数据
    return res;
  },
  (error) => {
    // 1. 处理 HTTP 错误（4xx/5xx）
    if (error.response) {
      const { status, data } = error.response;
      const requestType = error.config.headers?.type; // 获取请求 headers.type
      const redirectPath = requestType === "user" ? "/about" : "/login";

      switch (status) {
        case 401:
          router.push(redirectPath);
          ElMessage.error(data?.msg || "登录已过期，请重新登录");
          break;
        case 403:
          router.push(redirectPath);
          ElMessage.error(data?.msg || "无权限访问");
          break;
        case 404:
          ElMessage.error(data?.msg || "资源不存在");
          break;
        case 500:
          ElMessage.error(data?.msg || "服务器错误，请稍后重试");
          break;
        default:
          ElMessage.error(data?.msg || `请求失败，状态码: ${status}`);
      }
    } 
    // 2. 处理网络错误（无响应）
    else if (error.request) {
      ElMessage.error("网络错误，请检查连接");
    } 
    // 3. 处理请求配置错误
    else {
      ElMessage.error(error.message || "请求配置错误");
    }

    // 统一 reject，确保调用方可以捕获错误
    return Promise.reject(error);
  }
);
export default service;
